import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Footer from '../Footer/Footer';
import { Header } from '../header/Header';
import { changeCategoryLabel } from '../redux/slices/categorySlice';
import {
  Box,
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  Text,
  color,
} from '@chakra-ui/react';
import './contactus.css';
import { EmailIcon, PhoneIcon } from '@chakra-ui/icons';
import { Icon } from '@chakra-ui/react';
import { MdLocationOn } from 'react-icons/md';
import { addSiteMap } from '../redux/slices/sitemapSlice';
import http from '../http-common';

const Contactus = () => {
  const dispatch = useDispatch();
  const companysetting = useSelector(state => state.company);
  const basesitemaparr = useSelector(state => state.sitemap.sitemap);
  //console.log(companysetting);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(changeCategoryLabel(''));
    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.style.display = 'none';
      }, 1500);
    }
  }, ['']);
  async function getSitemapData(current_url) {
    let url = '/ecommerce_api/saveSitemap/';
    const res = await http
      .post(url, {
        AUTHORIZEKEY: '',
        url: current_url,
      })
      .then(res => {
        if (res.data[0].STATUS == 'SUCCESS') {
          dispatch(addSiteMap(res.data[0].DATA));
        } else {
          dispatch(addSiteMap([]));
        }
      });
  }
  useEffect(() => {
    const currentURL = window.location.href;
    const isInArray = basesitemaparr.includes(currentURL);
    if (isInArray) {
      console.log('Current URL is in the array.');
    } else {
      getSitemapData(currentURL);
    }
  }, [window.location.href]);
  return (
    <>
      <Header />
      <Box as={Container} maxW="7xl" mt={2} p={4} minH={'750px'}>
        <Box mt={20}>
          <Heading as="h1" size="xl" textAlign="center">
            Get in touch
          </Heading>
          <Heading as="h1" size="sm" textAlign="center" mt={2}>
            Our Friendliest Professionals are Ready to Assist You 24/7.
          </Heading>
        </Box>
        {companysetting.length > 0 &&
          companysetting.map(value => {
            return (
              <Grid
                templateColumns={{
                  base: 'repeat(1, 1fr)',
                  md: 'repeat(3, 1fr)',
                }}
                gap={6}
                mx={10}
                mt={20}
              >
                <GridItem
                  w="100%"
                  border="1px"
                  borderColor="gray.200"
                  p={14}
                  _hover={{ bg: 'white', boxShadow: 'xl' }}
                >
                  <Flex gap={3}>
                    <Icon
                      as={MdLocationOn}
                      w={8}
                      h={8}
                      style={{ color: `${value?.DATA?.theme_maincolor}` }}
                    />
                    <Box>
                      <Box>
                        <Heading
                          size="md"
                          style={{ color: `${value?.DATA?.theme_maincolor}` }}
                        >
                          Office address
                        </Heading>
                      </Box>
                      <Text mt={2}>
                        {value?.DATA?.company?.Companyinfo?.address_1 && (
                          <span>
                            {value.DATA.company.Companyinfo.address_1},{' '}
                          </span>
                        )}
                        {value?.DATA?.company?.Companyinfo?.address_2 && (
                          <span>
                            {value.DATA.company.Companyinfo.address_2},{' '}
                          </span>
                        )}
                        {value?.DATA?.company?.Companyinfo?.area && (
                          <span>
                            {value.DATA.company.Companyinfo.area},<br />
                          </span>
                        )}
                        {value?.DATA?.company?.Companyinfo?.state && (
                          <span>{value.DATA.company.Companyinfo.state}, </span>
                        )}
                        {value?.DATA?.company?.Companyinfo?.country && (
                          <span>{value.DATA.company.Companyinfo.country}</span>
                        )}
                        {value?.DATA?.company?.Companyinfo?.pincode && (
                          <span>
                            {' '}
                            - {value.DATA.company.Companyinfo.pincode}
                          </span>
                        )}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>
                <GridItem
                  w="100%"
                  border="1px"
                  borderColor="gray.200"
                  p={14}
                  _hover={{ bg: 'white', boxShadow: 'xl' }}
                >
                  <Flex gap={3}>
                    <PhoneIcon
                      w={8}
                      h={8}
                      style={{ color: `${value?.DATA?.theme_maincolor}` }}
                    />
                    <Box>
                      <Box>
                        <Heading
                          size="md"
                          style={{ color: `${value?.DATA?.theme_maincolor}` }}
                        >
                          Telephone number
                        </Heading>
                      </Box>
                      <Text mt={2}>
                        {value?.DATA?.company?.Companyinfo?.office_phone1 && (
                          <a
                            href={`tel:${value.DATA.company.Companyinfo.office_phone1}`}
                          >
                            +91 - {value.DATA.company.Companyinfo.office_phone1}
                          </a>
                        )}
                        {value?.DATA?.company?.Companyinfo?.office_phone1 &&
                          value?.DATA?.company?.Companyinfo?.office_phone2 && (
                            <br />
                          )}
                        {value?.DATA?.company?.Companyinfo?.office_phone2 && (
                          <a
                            href={`tel:${value.DATA.company.Companyinfo.office_phone2}`}
                          >
                            +91 - {value.DATA.company.Companyinfo.office_phone2}
                          </a>
                        )}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>
                <GridItem
                  w="100%"
                  border="1px"
                  borderColor="gray.200"
                  p={14}
                  _hover={{ bg: 'white', boxShadow: 'xl' }}
                >
                  <Flex gap={3}>
                    <EmailIcon
                      w={8}
                      h={8}
                      style={{ color: `${value?.DATA?.theme_maincolor}` }}
                    />
                    <Box>
                      <Box>
                        <Heading
                          size="md"
                          style={{ color: `${value?.DATA?.theme_maincolor}` }}
                        >
                          Email address
                        </Heading>
                      </Box>
                      <Text mt={2}>
                        {value?.DATA?.company?.Companyinfo?.email_address && (
                          <a
                            href={`mailto:${value.DATA.company.Companyinfo.email_address}`}
                          >
                            {value.DATA.company.Companyinfo.email_address}
                          </a>
                        )}
                      </Text>
                    </Box>
                  </Flex>
                </GridItem>
              </Grid>
            );
          })}
      </Box>
      <Footer />
    </>
  );
};

export default Contactus;
